var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tickIcon",on:{"click":_vm.tickClicked}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swal2-icon swal2-error swal2-animate-error-icon",staticStyle:{"display":"flex"}},[_c('span',{staticClass:"swal2-x-mark"},[_c('span',{staticClass:"swal2-x-mark-line-left"}),_c('span',{staticClass:"swal2-x-mark-line-right"})])])
}]

export { render, staticRenderFns }